import { Stack, useMediaQuery } from "@mui/material";

import { ShipperUpgradeNowButton } from "components/Shipper/components/ShipperUpgradeNowButton/ShipperUpgradeNowButton";

import { FreeTierBannerText } from "./components";
import { BANNER_TEXT_MIN_WIDTH } from "../../constants";

export function FreeTierShipperBanner() {
  const showText = useMediaQuery(BANNER_TEXT_MIN_WIDTH);

  return (
    <Stack direction="row" spacing={4} alignItems="center">
      {showText && <FreeTierBannerText />}
      <ShipperUpgradeNowButton
        buttonSize="large"
        trackingSource="free_tier_banner_upgrade_cta"
      />
    </Stack>
  );
}
